// // 上传地址
// export const UploadUrl = 'http://dev.ccsttc.com/upload';
// // OSS拼接域名
// export const FileHost = 'http://file.ccsttc.com/';

// 上传地址
export const UploadUrl = 'http://go.ccsttc.com/upload';
// OSS拼接域名
export const FileHost = 'http://file.ccsttc.com/';



// WEBPACK FOOTER //
// /Users/liyankai/Documents/github/seiya_web.git/src/app/lib/config.ts